import { DomainError } from "@econ-v1/domain";
export class CapabilityAuthorization {
    assertCapabilityDeclared(context, capability) {
        this.assertDeclared(context, capability);
    }
    assertEventDeclared(context, eventType) {
        this.assertDeclared(context, eventType);
    }
    assertQueryDeclared(context, queryName) {
        this.assertDeclared(context, queryName);
    }
    assertDeclared(context, declaration) {
        if (context.requires.includes(declaration))
            return;
        throw new DomainError({
            code: "capability_not_declared",
            details: { appName: context.appName, declaration },
            message: `${context.appName} did not declare ${declaration}`,
        });
    }
}
//# sourceMappingURL=authorization.js.map